// extracted by mini-css-extract-plugin
export var ModalHeader = "ModalHeader-module--ModalHeader--CY+I1";
export var ModalHeaderCloseButton = "ModalHeader-module--ModalHeaderCloseButton--qfayq";